export const higherThan1000Regex = '(?:100[1-9]|10[1-9]\\d|1[1-9]\\d{2,}|[2-9]\\d{3,}|[1-9]\\d{4,})';
export const higherThan0Regex = '(?!0+)\\d+';
export const differentThan90Regex = '(?!90+)\\d+';
export const differentThan0Regex = '(?!0+)\\d+';
export const differentThan1000Regex = '(?!1000+)\\d+';
export const moreThan5WordsRegex = '[\\w ]{5,}';
export const higherThan999Regex = '\\d{4,}';
export const lessThan1000 = '0|[1-9]\\d{0,2}';
export const onlyLettersRegex = '[A-Za-zÁÉÍÓÚáéíóúÑñÜü]';
export const greenColorRegex = '(153,255,153|102,255,153|51,255,51|51,204,0|0,153,0|0,102,0|0,51,0)';
export const redColorRegex = '(255,204,204|255,102,102|255,0,0|204,0,0|153,0,0|102,0,0)';